/* globals process */
/* Service to send requests to python api */

import axios from "axios";
import store from "@/plugins/store/store";
import UtilsService from "@/services/UtilsService";

export default () => {
  if (!process.env.PYTHON_API_URL) {
    throw new Error("PYTHON_API_URL environment variable not specified");
  }
  const headers = {};
  if (store.state.token) {
    headers.Authorization = `Bearer ${store.state.token}`;
  }
  const ax = axios.create({
    baseURL: process.env.PYTHON_API_URL,
    headers
  });

  ax.interceptors.response.use(
    // If response is successfull, send it through
    response => {
      const newToken = response.headers['authorization'] && response.headers['authorization'].split(" ")[1];

      if (newToken)
        store.dispatch("setToken", newToken);

      return response;
    },
    // If error happened:
    error => {
      if (error.response) {
        // And the error type is unauthorized
        if (error.response.status && error.response.status === 401) {
          // If the token is in the store
          if (store.state.isUserLoggedIn || store.state.token || store.state.user) {
            // Clear the token, user data and cached module state
            store.dispatch("setToken", null);
            store.dispatch("setUser", null);
            store.dispatch("clearAll");
          }
          // Return to login page
          UtilsService.redirectToLogin();
          return error.response;
        }
        return error.response;
      } else {
        return error;
      }
    }
  );

  return {
    get: async (path, params = new URLSearchParams()) => {
      return ax.get(path + '?' + params.toString())
    },
    post: async (path, body) => {
      return ax.post(path, body)
    },
    put: async (path, params) => {
      return ax.put(path, params)
    },
    delete: async (path, params = new URLSearchParams(), body = undefined) => {
      return ax.delete(path + '?' + params.toString(), {
        data: body
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/services/PythonApi.js